<!-- Electrical Wiring / Electrical Wiring (Controls) / Wiring Interlocks-->
<div class="row pe-3 ps-3">
    <div class="col-sm-12">
        <fieldset class="border rounded-3 p-1" *ngIf="isFireOrSecurity || isAem" [class.section-disabled]="isSectionFieldsetDisabled('electricalWiringFormGroup')">
            <legend class="float-none w-auto   font-size-13" *ngIf="isFireOrSecurity">{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('electricalWiringFormGroup')" (change)="onSectionToggle('electricalWiringFormGroup', $event)"></si-check-box></legend>
            <legend class="float-none w-auto   font-size-13" *ngIf="isAem">{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.ELECTRICAL_WIRING_CONTROLS' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('electricalWiringFormGroup')" (change)="onSectionToggle('electricalWiringFormGroup', $event)"></si-check-box></legend>
    <div class="row" [formGroup]="electricalWiringFormGroup" trackChanges>
        <div class="col-sm-6">
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.ELECTRICAL_SUBCONTRACTOR' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 break-word">
                    <app-si-form-field formControlName="electricalSubcontractor" [maxlength]="40"
                            [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.AMOUNT_BUDGETED' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <app-si-currency-field formControlName="amountBudgeted" [max]="999999999.99"
                     [isReadMode]="isReadMode" [isDisabled]="isDisabled"></app-si-currency-field>
                </div>
            </div>
            <div class="row bottomPadding">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.THREE_BIDS_SECURED' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="threeBidsSecured" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'threeBidsSecured')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'threeBidsSecured')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.VENDOR_NAME_BID' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                     <app-si-form-field [maxlength]="40" [inputValue]="formControlsValueForString(electricalWiringFormGroup,'vendorNameBidOne')"
                            [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.VENDOR_NAME_BID' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <app-si-form-field [maxlength]="40" [inputValue]="formControlsValueForString(electricalWiringFormGroup,'vendorNameBidTwo')"
                            [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.VENDOR_NAME_BID' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <app-si-form-field [maxlength]="40" [inputValue]="formControlsValueForString(electricalWiringFormGroup,'vendorNameBidThree')"
                            [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding"  *ngIf="business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || business === constants.BUSINESS_FIRE  || (business === constants.BUSINESS_MECHANICAL)">   
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.REQUESTED_QUOTES_FROM' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 break-word">
                    <app-si-form-field formControlName="requestedQuotesFrom" [maxlength]="40"
                            [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                    </app-si-form-field>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || business === constants.BUSINESS_FIRE  || (business === constants.BUSINESS_MECHANICAL)) && isSalePriceGreaterThan150">   
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.FPM_INVOLVED' | translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="fpmInvolved" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'fpmInvolved')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'fpmInvolved')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(business === constants.BUSINESS_SECURITY) && isSalePriceGreaterThan150">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SECURITY_PM_INVOLVED' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 mt-3">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="securityPMInvolved" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'securityPMInvolved')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'securityPMInvolved')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">   
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.QUOTE_VARIANCE' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <app-si-currency-field formControlName="quoteVariance"  [max]="99999.99"
                        [isReadMode]="isReadMode" [isDisabled]="isDisabled"></app-si-currency-field>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">   
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.RECEIVED_BINDING_QUOTE' | translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="receivedBindingQuote" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'receivedBindingQuote')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'receivedBindingQuote')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="isAem">   
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_IS_BAU_CERTIFIED' | translate}} </mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="subIsBauCertified" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subIsBauCertified')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subIsBauCertified')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
              <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_HAS_PROJECT_SPECIFICATIONS' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="subHasProjectSpecifications" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasProjectSpecifications')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasProjectSpecifications')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_HAS_CAPACITY_TO_COMPLETE_WORK' | translate}}</mat-label>
                </div>
                
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="subHasCapacityToCompleteWork" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasCapacityToCompleteWork')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasCapacityToCompleteWork')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business !== constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_CARRIES_BOND' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 d-flex flex-row">
                    <div class="d-flex flex-row align-items-center sub-carries-bond-container">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                            formControlName="subCarriesBond" [disabled]="isReadMode">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subCarriesBond')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subCarriesBond')">
                            </si-radio-button>
                        </mat-radio-group>
                        <div class="break-word d-flex align-items-center form-field-container">
                        <app-si-form-field formControlName="subCarriesBondReason" [maxlength]="40"
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled || isControlValueEqualToTranslation(electricalWiringFormGroup, 'subCarriesBond', 'YES')">
                        </app-si-form-field>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="col-sm-6">
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_HAS_PROJECT_SPECIFICATIONS' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="subHasProjectSpecifications" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasProjectSpecifications')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasProjectSpecifications')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_HAS_CAPACITY_TO_COMPLETE_WORK' | translate}}</mat-label>
                </div>
                
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="subHasCapacityToCompleteWork" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasCapacityToCompleteWork')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subHasCapacityToCompleteWork')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUB_CARRIES_BOND' | translate}}</mat-label>
                </div>
            
                <div class="col-sm-6 d-flex flex-row">
                    <div class="d-flex flex-row align-items-center sub-carries-bond-container">
                        <mat-radio-group class="radio-group radio-btns d-flex flex-row" formControlName="subCarriesBond"
                            [disabled]="isReadMode">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"
                                [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subCarriesBond')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled"
                                [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subCarriesBond')">
                            </si-radio-button>
                        </mat-radio-group>
                        <div class="break-word d-flex align-items-center form-field-container">
                            <app-si-form-field formControlName="subCarriesBondReason" [maxlength]="40" [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled || formControlsValueForString(electricalWiringFormGroup, 'subCarriesBond') === constants.YES">
                            </app-si-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SUBS_NOTIFIED_SECURITY' | translate}}</mat-label>
                </div>
                
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="subsNotifiedSecurity" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subsNotifiedSecurity')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'subsNotifiedSecurity')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_FIRE) || isSalePriceGreaterThan150">
                <div class="col-sm-6" >
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.CONTRACT_VALUE' | translate}}</mat-label>
                </div>
                
                <div class="col-sm-6">
                    <app-si-currency-field formControlName="contractValue" [max]="99999.99"
                        [isReadMode]="isReadMode" [isDisabled]="isDisabled"></app-si-currency-field>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_SECURITY)&& isSalePriceGreaterThan150">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.CONDUIT_REQUIRED' | translate}}</mat-label>
                </div>
                
                <div class="col-sm-6 mt-3">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="conduitRequired" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'allConduitRequired')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'allConduitRequired')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(isValueEqualToTranslation(getParameterValues(constants.YES_NO,costReviewElectricalWiring.allConduitRequired), 'YES')) && (business=== constants.BUSINESS_SECURITY)&& isSalePriceGreaterThan150">
                <div class="col-sm-6">
                    <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.CONDUIT_TYPE_YES' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 mt-3">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="conduitType" [disabled]="isReadMode">
                    <si-radio-button [displayText]="'ELECTRICAL_WIRING_TYPE_EMT' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'conduitType')">
                    </si-radio-button>
                    <si-radio-button [displayText]="'ELECTRICAL_WIRING_TYPE_RIGID' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'conduitType')">
                    </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_SECURITY)">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.FIBER_OPTICS_REQUIRED' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="fiberOpticsSecurity" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'fiberOpticsSecurity')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'fiberOpticsSecurity')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL  || (business === constants.BUSINESS_MECHANICAL))&& isSalePriceGreaterThan150">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.WIRING_TYPE' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="wiringType" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'ELECTRICAL_WIRING_TYPE_EMT' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'wiringType')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'ELECTRICAL_WIRING_TYPE_RIGID_CONDUIT' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'wiringType')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="business=== constants.BUSINESS_FIRE">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.CONDUIT_TYPE' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="conduitType" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'ELECTRICAL_WIRING_TYPE_EMT' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'conduitType')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'ELECTRICAL_WIRING_TYPE_RIGID_CONDUIT' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'conduitType')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || business === constants.BUSINESS_FIRE || (business === constants.BUSINESS_MECHANICAL))">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.ALL_CONDUIT_REQUIRED' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 mt-3">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="allConduitRequired" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'allConduitRequired')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'allConduitRequired')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || business === constants.BUSINESS_FIRE || (business === constants.BUSINESS_MECHANICAL))">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.MINIMUM_CONDUIT_SIZE' | translate}}</mat-label>
                </div>
                <div class="col-sm-6 mt-3">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-column"
                        formControlName="minimumConduitSize" [disabled]="isReadMode">
                        <div class="d-flex flex-row">
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_HALF_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_HALF_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_THREE_QUARTER_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_THREE_QUARTER_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_ONE_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_ONE_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_ONE_AND_QUARTER_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_ONE_AND_QUARTER_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                        </div>
                        <div class="d-flex flex-row">
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_ONE_AND_HALF_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_ONE_AND_HALF_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_ONE_AND_THREE_QUARTER_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_ONE_AND_THREE_QUARTER_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'MINIMUM_CONDUIT_SIZE_TWO_INCH' | translate" [value]="'MINIMUM_CONDUIT_SIZE_TWO_INCH'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                            <si-radio-button [displayText]="'OTHER' | translate" [value]="'OTHER'" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'minimumConduitSize')">
                            </si-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row bottomPadding" *ngIf="(business === constants.BUSINESS_FIRE)">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.CONTRACTOR_SUBCONTRACTOR_HAS_DPU' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="contractorSubcontractorHasDPU" [disabled]="isReadMode">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'contractorSubcontractorHasDPU')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'contractorSubcontractorHasDPU')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row bottomPadding" *ngIf="(business === constants.BUSINESS_FIRE)">
                <div class="col-sm-6">
                    <mat-label class="ps-5"> {{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.IF_NO_WILL_ONE_BE_PROVIDED' | translate}}</mat-label>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                        formControlName="ifNoWillOneBeProvided" [disabled]="isReadMode || !isSubcontractorHasDPUNotSelected">
                        <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'ifNoWillOneBeProvided')">
                        </si-radio-button>
                        <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(electricalWiringFormGroup, 'ifNoWillOneBeProvided')">
                        </si-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row bottomPadding" *ngIf="(business=== constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || (business === constants.BUSINESS_MECHANICAL) || (business === constants.BUSINESS_FIRE))">
                <div class="col-sm-6">
                    <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.SAFETIES_FURNISHED_BY' | translate}}</mat-label>
        </div>
                <div class="col-sm-6 break-word mt-3">
                    <app-si-form-field formControlName="safetiesFurnishedBy" [maxlength]="40" [isReadMode]="isReadMode">
                    </app-si-form-field>
        </div>
            </div>
        </div>
        </div>

          <!-- Wiring Responsibities-->
        <div class="row ps-0 pe-0" *ngIf="isFireOrSecurity">
        <div class="container-fluid h-100">
            <fieldset class="border rounded-3 p-1 h-100"
                [formGroup]="wiringResponsibilitiesFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('wiringResponsibilitiesFormGroup')" trackChanges>
                <legend class="float-none w-auto   font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('wiringResponsibilitiesFormGroup')" (change)="onSectionToggle('wiringResponsibilitiesFormGroup', $event)"></si-check-box></legend>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FIELD_TERMINATIONS' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="fieldTerminations" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fieldTerminations')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fieldTerminations')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.PANEL_TERMINATIONS' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="panelTerminations" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'panelTerminations')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'panelTerminations')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        @if( business === constants.BUSINESS_FIRE ) {

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.PAD_AND_REMOTE_ANNUNCIATOR' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="padAndRemoteAnnunciator" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'padAndRemoteAnnunciator')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'padAndRemoteAnnunciator')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.HIGH_VOLTAGE_WIRING' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="highVoltageWiring" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'highVoltageWiring')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'highVoltageWiring')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.SUPPLY_24VDC' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="supply24Vdc" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'supply24Vdc')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'supply24Vdc')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.THIRD_PARTY_TERMINATIONS' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="thirdPartyTerminations" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'thirdPartyTerminations')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'thirdPartyTerminations')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FIBER_OPTICS_REQUIRED' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="fiberOpticsRequired" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberOpticsRequired')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberOpticsRequired')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                    }

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FIBER_FURNISHED_BY' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="fiberFurnishedBy" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberFurnishedBy')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberFurnishedBy')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FIBER_INSTALLED_BY' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="fiberInstalledBy" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberInstalledBy')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberInstalledBy')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FIBER_TERMINATIONS_BY' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="fiberTerminationsBy" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberTerminationsBy')"></si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fiberTerminationsBy')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_SECURITY">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.POWER_WIRING' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="powerWiring" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'powerWiring')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'powerWiring')">
                                    </si-radio-button>
                                </mat-radio-group>  
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        @if(business === constants.BUSINESS_FIRE) {
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.DUCT_HOUSINGS_AND_SAMPLING' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="ductHousingsAndSampling" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'ductHousingsAndSampling')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'ductHousingsAndSampling')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.PROVIDES_POWER_FOR_ENCLOSURE_HEATERS' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="providesPowerForEnclosureHeaters" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'providesPowerForEnclosureHeaters')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'providesPowerForEnclosureHeaters')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FIRE_SMOKE_DAMPER_VALVE' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="fireSmokeDamperValve" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fireSmokeDamperValve')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'fireSmokeDamperValve')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.POWER_FOR_ACTUATORS_FURNISHED_BY' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="powerForActuatorsFurnishedBy" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'powerForActuatorsFurnishedBy')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'powerForActuatorsFurnishedBy')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                    }

                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.WIRE_CABLING_FURNISHED_BY'
                                    | translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="wireCablingFurnishedBy" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'wireCablingFurnishedBy')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'wireCablingFurnishedBy')">
                                    </si-radio-button>
                                </mat-radio-group>  
                            </div>
                        </div>

                        @if(business === constants.BUSINESS_SECURITY) {
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.LOW_VOLTAGE_WIRING' |
                                    translate}}</mat-label>
                            </div>

                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="lowVoltageWiring" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'lowVoltageWiring')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'lowVoltageWiring')">
                                    </si-radio-button>
                                </mat-radio-group>  
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.DEVICES_INSTALLED' |
                                    translate}}</mat-label>
                            </div>

                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="devicesInstalled" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'devicesInstalled')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'devicesInstalled')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.DEVICES_WIRED' |
                                    translate}}</mat-label>
                            </div>

                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="devicesWired" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'devicesWired')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'devicesWired')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.EQUIPMENT_INSTALLED' |
                                    translate}}</mat-label>
                            </div>

                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="equipmentInstalled" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'equipmentInstalled')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'equipmentInstalled')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                    }

                        <div class="row bottomPadding" *ngIf="business === constants.BUSINESS_FIRE">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.FREE_RUN_CABLE_ACCEPTABLE' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                    formControlName="freeRunCableAcceptable" [disabled]="isReadMode">
                                    <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'freeRunCableAcceptable')">
                                    </si-radio-button>
                                    <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringResponsibilitiesFormGroup, 'freeRunCableAcceptable')">
                                    </si-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1"
                *ngIf="!costReviewFireEnUsWiringResponsibilities?.isWiringResponsibilitiesApplicable && isReadMode">
                <legend class="float-none w-auto   font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.WIRING_RESPONSIBILITIES.TITLE' | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
        </div>

        <!-- Wiring Interlocks -->
        <div class="row pe-3 ps-3" *ngIf="isAem">
            <div class="container-fluid">
                <fieldset class="border rounded-3 p-1" [class.section-disabled]="isSectionFieldsetDisabled('wiringInterlockFormGroup')">
                    <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('wiringInterlockFormGroup')" (change)="onSectionToggle('wiringInterlockFormGroup', $event)"></si-check-box></legend>
            <div class="row" [formGroup]="wiringInterlockFormGroup" trackChanges>
                <div class="col-sm-6">
                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.BOILER_CHILLER_WIRING_DETAILED' | translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="boilerChillerWiringDetailed" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'boilerChillerWiringDetailed')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'boilerChillerWiringDetailed')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"  *ngIf="isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.FLOW_SWITCHES_PUMP_INTERLOCKS_WIRED_BY' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="flowSwitchesWiredBy" [maxlength]="40" 
                                [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                            </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.CHEMICAL_FEED_SYSTEM_WIRING_REQUIRED' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="chemicalFeedSystemWiringRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'chemicalFeedSystemWiringRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'chemicalFeedSystemWiringRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"  >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.SUMP_LEVEL_CONTROLLER_WIRING_REQUIRED' | translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="sumpLevelControllerWiringRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'sumpLevelControllerWiringRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'sumpLevelControllerWiringRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                            
                        </div>
                    </div>
                    <div class="row bottomPadding"  >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.OTHER' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="other" [maxlength]="40" 
                            [isReadMode]="isReadMode" [isDisabled]="isDisabled" ></app-si-form-field>
                        </div>
                    </div>

                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.SPLIT_SYSTEM_DX_WIRING_REQUIRED' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="splitSystemDxWiringRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'splitSystemDxWiringRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'splitSystemDxWiringRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.EXHAUST_FAN_WIRING' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="exhaustFanWiring" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'exhaustFanWiring')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'exhaustFanWiring')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.EXHAUST_FAN_DAMPER_INTERLOCKS' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="exhaustFanDamperInterlocks" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'exhaustFanDamperInterlocks')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'exhaustFanDamperInterlocks')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.COOLING_TOWER_WIRING' | translate}} </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                            <si-check-box-group
                                [options]="coolingTowerWiringOptions"
                                [isReadMode]="isReadMode"
                                [isDisabled]="isDisabled"
                                formControlName="coolingTowerWiring"
                                [singleRow]="true" [columnsPerRow]="2">
                            </si-check-box-group>
                            </div>
                        </div>
                    </div>
                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.PANEL_POWER_WIRED_BY' | translate}}</mat-label>
                        </div>
                        
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="panelPowerWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'panelPowerWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'panelPowerWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.SMOKE_DETECTORS_INSTALLED_BY' | translate}}</mat-label>
                        </div>
                        
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="smokeDetectorsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'smokeDetectorsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'smokeDetectorsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.SMOKE_DETECTORS_FURNISHED_BY' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="smokeDetectorsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'smokeDetectorsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'smokeDetectorsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.INTERLOCKS_120_VOLT' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="interlocks120Volt" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'interlocks120Volt')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'interlocks120Volt')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" *ngIf="isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.SMOKE_DETECTORS_LOCATED_BY' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="smokeDetectorsLocatedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'smokeDetectorsLocatedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'smokeDetectorsLocatedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" >
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.WIRING_INTERLOCKS.SIEMENS_PANELS_POWERED_BY' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="siemensPanelsPoweredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'siemensPanelsPoweredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(wiringInterlockFormGroup, 'siemensPanelsPoweredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
                </div>
            </fieldset>
            </div>
        </div>

        </fieldset>
        <fieldset class="border rounded-3 p-1" *ngIf="(isFireOrSecurity || isAem) && !costReviewElectricalWiring?.isElectricalWiringApplicable && isReadMode">
            <legend class="float-none w-auto   font-size-13" *ngIf="isFireOrSecurity">{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.TITLE' | translate}}</legend>
            <legend class="float-none w-auto   font-size-13" *ngIf="business === constants.BUSINESS_AUTOMATION || business === constants.BUSINESS_ELECTRICAL || (business === constants.BUSINESS_MECHANICAL)">{{'REVIEW_SOL_CHECKLIST_TAB.ELECTRICAL_WIRING.ELECTRICAL_WIRING_CONTROLS' | translate}}</legend>
            <div class="row bottomPadding">
                <div class="col-sm-12">
                    <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                </div>
            </div>
        </fieldset>
    </div>
</div>

<!-- System Interfaces-->
    <div class="row" *ngIf="isFire">
        <div class="col-sm-12">
            <div class="container-fluid">
                <fieldset class="border rounded-3 p-1 mb-0" *ngIf="systemInterfacesFormGroup"
                    [formGroup]="systemInterfacesFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('systemInterfacesFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_INTERFACES.TITLE'| translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('systemInterfacesFormGroup')" (change)="onSectionToggle('systemInterfacesFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-3">
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_FIRE_DOORS_HOLDERS_ROLL_DOWN' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(1)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 1, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_PRE_ACTION_RELEASING' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(2)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 2, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_FIRE_PUMP' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(3)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 3, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_ELEVATOR_CONTROLS' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(4)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 4, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_HVAC_BAS' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(5)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 5, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_OCCUPANT_EVACUATION_OPERATION_OEO' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(6)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 6, $event)"></si-check-box>
                                </div>
                                <div class="col-sm-3">
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_SMOKE_CONTROL' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(7)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 7, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_FIRE_SMOKE_DAMPERS' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(8)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 8, $event)"></si-check-box>
                                    <div class= "d-flex flex-column ps-5">
                                        <si-check-box [displayText]="'SYSTEM_INTERFACES_POSITIVE_INDICATION_REQUIRED' | translate" [isReadMode]="isReadMode" [isDisabled]="isFireSmokeDampersDisabled" class="w-100"
                                        [isChecked]="isFireSmokeDampersSelected(1)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'fireSmokeDampers', 1, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_SIEMENS_PROVIDES_SWITCHES' | translate" [isReadMode]="isReadMode" [isDisabled]="isFireSmokeDampersDisabled" class="w-100"
                                        [isChecked]="isFireSmokeDampersSelected(2)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'fireSmokeDampers', 2, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_SIEMENS_PROVIDES_SMOKE_FIRE_DAMPERS' | translate" [isReadMode]="isReadMode" [isDisabled]="isFireSmokeDampersDisabled" class="w-100"
                                        [isChecked]="isFireSmokeDampersSelected(3)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'fireSmokeDampers', 3, $event)"></si-check-box>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_SECURITY_SYSTEM' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(9)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 9, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_LIGHTING' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(10)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 10, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_GENERATOR' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(11)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 11, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_GAS_HAZARDOUS_MATERIAL_DETECTION' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(12)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 12, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_GRAPHIC_MAPS' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(13)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 13, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_LED_ANNUNCIATORS' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(14)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 14, $event)"></si-check-box>
                                    <div class="d-flex flex-row ps-5">
                                        <si-check-box [displayText]="'SYSTEM_INTERFACES_DIRECTORY' | translate" [isReadMode]="isReadMode"  [isDisabled]="isLedAnnunciatorDisabled" class="w-100"
                                            [isChecked]="isLedAnnunciatorSelected(1)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'ledAnnunciator', 1, $event)"></si-check-box>
                                        <si-check-box [displayText]="'SYSTEM_INTERFACES_POINT' | translate" [isReadMode]="isReadMode" [isDisabled]="isLedAnnunciatorDisabled" class="w-100"
                                            [isChecked]="isLedAnnunciatorSelected(2)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'ledAnnunciator', 2, $event)"></si-check-box>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_ALPHA_NUMERIC_ANNUNCIATORS' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(15)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 15, $event)"></si-check-box>
                                    <div class="d-flex flex-row ps-5">
                                        <si-check-box [displayText]="'SYSTEM_INTERFACES_TEXT' | translate" [isReadMode]="isReadMode" [isDisabled]="isAlphaNumericAnnunciatorDisabled" class="w-100"
                                            [isChecked]="isAlphaNumericAnnunciatorSelected(1)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'alphaNumericAnnunciator', 1, $event)"></si-check-box>
                                        <si-check-box [displayText]="'SYSTEM_INTERFACES_GRAPHICS' | translate" [isReadMode]="isReadMode" [isDisabled]="isAlphaNumericAnnunciatorDisabled" class="w-100"
                                            [isChecked]="isAlphaNumericAnnunciatorSelected(2)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'alphaNumericAnnunciator', 2, $event)"></si-check-box>
                                    </div>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_PRINTER' | translate" [isReadMode]="isReadMode"
                                        [isChecked]="isSystemInterfacesSelected(16)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 16, $event)"></si-check-box>
                                    <si-check-box [displayText]="'SYSTEM_INTERFACES_OTHER' | translate" [isReadMode]="isReadMode" 
                                        [isChecked]="isSystemInterfacesSelected(17)" (change)="updateNumberArrayControl(systemInterfacesFormGroup, 'systemInterfaces', 17, $event)"></si-check-box>
                                    <si-text-area formControlName="otherNotes" [isReadMode]="isReadMode" [isDisabled]="isOtherNotesDisabled"> 
                                    </si-text-area>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1"
                   *ngIf=" !costReviewSystemInterfaces?.isSystemInterfacesApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.SYSTEM_INTERFACES.TITLE'| translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>

    <!-- Dampers and Smoke Dampers -->
    <div class="row" *ngIf="isAem && costReviewDamperActuators">
        <div class="col-sm-6 pe-0">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100" 
                    [formGroup]="dampersFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('dampersFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.TITLE'
                        | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('dampersFormGroup')" (change)="onSectionToggle('dampersFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.RECEIVED_BINDING_QUOTE' | translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="receivedBindingQuote" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'receivedBindingQuote')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'receivedBindingQuote')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.DAMPER_QUOTE_AMOUNT' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                             <app-si-form-field formControlName="damperQuoteAmount" [type]="'number'" [maxlength]="5" [max]="99999"
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.NUMBER_OF_DAMPERS' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <app-si-form-field formControlName="numberOfDampers" [type]="'number'" [maxlength]="4" [max]="9999"
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.MANUFACTURER' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer" [maxlength]="40" 
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.ACTUATORS_FURNISHED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="actuatorsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'actuatorsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'actuatorsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.ACTUATORS_INSTALLED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="actuatorsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'actuatorsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'actuatorsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.ACTUATORS_WIRED_BY' | translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="actuatorsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'actuatorsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(dampersFormGroup, 'actuatorsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.SPECIAL_APPLICATIONS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                        <app-si-form-field formControlName="specialApplications" [maxlength]="40"  
                        [isReadMode]="isReadMode">
                        </app-si-form-field>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewDamperActuators?.isDampersApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.DAMPERS.TITLE'
                        | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="col-sm-6 ps-0" *ngIf="showSmokeDampersSection">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100" 
                    [formGroup]="smokeDampersFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('smokeDampersFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.TITLE' |translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('smokeDampersFormGroup')" (change)="onSectionToggle('smokeDampersFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.RECEIVED_BINDING_QUOTE'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="receivedBindingQuote" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'receivedBindingQuote')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'receivedBindingQuote')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf="isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.SMOKE_DAMPER_QUOTE_AMOUNT'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                             <app-si-form-field formControlName="smokeDamperQuoteAmount" [type]="'number'" [maxlength]="5" [max]="99999"
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.NUMBER_OF_SMOKE_DAMPERS'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                             <app-si-form-field formControlName="numberOfDampers" [type]="'number'" [maxlength]="4" [max]="9999"
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                            
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.MANUFACTURER' |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer" [maxlength]="40" 
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.ACTUATORS_FURNISHED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="actuatorsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'actuatorsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'actuatorsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"*ngIf=" isSalePriceGreaterThan150">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.ACTUATORS_WIRED_BY'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="actuatorsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'actuatorsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'actuatorsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                       *ngIf=" smokeDampersFormGroup.get('smokeDamperEndSwitchMonitoring')?.value">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.SMOKE_DAMPER_END_SWITCH_MONITORING'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="smokeDamperEndSwitchMonitoring" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'smokeDamperEndSwitchMonitoring')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'smokeDamperEndSwitchMonitoring')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.IF_YES_WIRING'
                                |translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="ifYesWiring" [disabled]="isReadMode">
                                <si-radio-button [displayText]="getParameterValues(constants.HARDWIRED_SOFTWARE, 1)" [isReadMode]="isReadMode" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'ifYesWiring')"
                                    [isDisabled]="isDisabled || !isControlValueEqualToTranslation(smokeDampersFormGroup, 'smokeDamperEndSwitchMonitoring', 'YES')">
                                </si-radio-button>
                                <si-radio-button [displayText]="getParameterValues(constants.HARDWIRED_SOFTWARE, 2)" [isReadMode]="isReadMode" [selectedValue]="formControlsValueForString(smokeDampersFormGroup, 'ifYesWiring')"
                                    [isDisabled]="isDisabled || !isControlValueEqualToTranslation(smokeDampersFormGroup, 'smokeDamperEndSwitchMonitoring', 'YES')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewSmokeDampers?.isSmokeDampersApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.SMOKE_DAMPERS.TITLE' |translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>

    <!-- Metering and Integration-->
    <div class="row"
        *ngIf="isAem && isSalePriceGreaterThan150">
        <div class="col-sm-6 pe-0" *ngIf="costReviewMetering">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100" 
                    [formGroup]="meteringFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('meteringFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.METERING.TITLE'
                        | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('meteringFormGroup')" (change)="onSectionToggle('meteringFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.METERING.MANUFACTURER' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                            <app-si-form-field formControlName="manufacturer" [maxlength]="40" 
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.METERING.INSTALLATION' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="installation" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'HARD_WIRED' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'installation')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'INTEGRATION' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'installation')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.METERING.UNITS_FURNISHED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'unitsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'unitsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.METERING.UNITS_INSTALLED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'unitsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'unitsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.METERING.UNITS_WIRED_BY' | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'unitsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(meteringFormGroup, 'unitsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewMetering?.isMeteringApplicable && isReadMode">
                    <legend class="float-none w-auto   font-size-13">{{'REVIEW_SOL_CHECKLIST_TAB.METERING.TITLE'
                        | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="col-sm-6 ps-0">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100"
                    [formGroup]="integrationFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('integrationFormGroup')" trackChanges>
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('integrationFormGroup')" (change)="onSectionToggle('integrationFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding" *ngIf="costReviewIntegration">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.SYSTEM_REQUIRE_INTEGRATION' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6 break-word">
                                    <app-si-form-field formControlName="systemsThatRequireIntegration" [maxlength]="40" 
                                    [isReadMode]="isReadMode" [isDisabled]="isDisabled">
                                </app-si-form-field>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.INTEGRATION_PROTOCOL' | translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <div class="aligned-options-container">
                                <si-check-box [displayText]="'BACnet'" [isReadMode]="isReadMode"
                                    [isChecked]="isIntegrationProtocolSelected(1)" (change)="updateNumberArrayControl(integrationFormGroup, 'integrationProtocol', 1, $event)"></si-check-box>
                                <si-check-box [displayText]="'MODBUS'" [isReadMode]="isReadMode"
                                    [isChecked]="isIntegrationProtocolSelected(2)" (change)="updateNumberArrayControl(integrationFormGroup, 'integrationProtocol', 2, $event)"></si-check-box>
                                <si-check-box [displayText]="'KNX'" [isReadMode]="isReadMode"
                                    [isChecked]="isIntegrationProtocolSelected(3)" (change)="updateNumberArrayControl(integrationFormGroup, 'integrationProtocol', 3, $event)"></si-check-box>
                                <si-check-box [displayText]="'GAMMA'" [isReadMode]="isReadMode"
                                    [isChecked]="isIntegrationProtocolSelected(4)" (change)="updateNumberArrayControl(integrationFormGroup, 'integrationProtocol', 4, $event)"></si-check-box>
                                <si-check-box [displayText]="'OTHER' | translate" [isReadMode]="isReadMode"
                                    [isChecked]="isIntegrationProtocolSelected(5)" (change)="updateNumberArrayControl(integrationFormGroup, 'integrationProtocol', 5, $event)"></si-check-box>
                            </div>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.UNITS_FURNISHED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsFurnishedBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'unitsFurnishedBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'unitsFurnishedBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.UNITS_INSTALLED_BY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsInstalledBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'unitsInstalledBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'unitsInstalledBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.UNITS_WIRED_BY' | translate}}
                            </mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unitsWiredBy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'unitsWiredBy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'unitsWiredBy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.GRAPHICS_REQUIRED' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="graphicsRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'graphicsRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(integrationFormGroup, 'graphicsRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1" *ngIf="!costReviewIntegration.isIntegrationApplicatble && isReadMode">
                    <legend class="float-none w-auto   font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.INTEGRATION.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>



    <!-- Management Station -->
    <div class="row padding-left-rt-12"
        *ngIf="isSecurity && costReviewSecurityEnUsManagementStation">
        <div class="container-fluid">
            <fieldset class="border rounded-3 p-1"
                [formGroup]="managementStationFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('managementStationFormGroup')" trackChanges>
                <legend class="float-none w-auto   font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.MANAGEMENT_STATION.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('managementStationFormGroup')" (change)="onSectionToggle('managementStationFormGroup', $event)"></si-check-box></legend>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row bottomPadding">
                            <div class="col-sm-6">
                                <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.MANAGEMENT_STATION.TITLE' |
                                    translate}}</mat-label>
                            </div>
                            <div class="col-sm-6">
                                <si-combo-box
                                [inputValue]="formControlsValueForString(managementStationFormGroup, 'managementStation')"
                                [isReadMode]="isReadMode" [dropDownList]="managementStationList" [isDisabled]="isDisabled">
                                </si-combo-box>
                           </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="border rounded-3 p-1"
                *ngIf="!costReviewSecurityEnUsManagementStation?.isManagementStationChecked && isReadMode">
                <legend class="float-none w-auto   font-size-13">
                    {{'REVIEW_SOL_CHECKLIST_TAB.MANAGEMENT_STATION.TITLE' | translate}}</legend>
                <div class="row bottomPadding">
                    <div class="col-sm-12">
                        <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>

    <!--Execution Schedule and  Outside Purchases (Fire)-->
    <div class="row fit-to-row-height" *ngIf="isFire">
        <div class="col-sm-6 pe-0"
            *ngIf="isFire && costReviewFireEnUsExecutionSchedule">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100"
                    [formGroup]="executionScheduleFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('executionScheduleFormGroup')" trackChanges>
                    <legend class="float-none w-auto font-size-13">
                        @if (optionalWorkflowCondition) {
                        <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('executionScheduleFormGroup')" (change)="onSectionToggle('executionScheduleFormGroup', $event)"></si-check-box>
                        }
                        {{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.TITLE' | translate}}</legend>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.PHASED_INSTALLATION_OCCUPANCY' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="phasedInstallationOccupancy" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'phasedInstallationOccupancy')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'phasedInstallationOccupancy')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="isFireOrSecurity">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.PROJECT_SCHEDULE_PUBLISHED' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="projectSchedulePublished" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'projectSchedulePublished')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'projectSchedulePublished')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.FIRE_PLAN_IDENTIFIED' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="firePlanIdentified" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'firePlanIdentified')"></si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'firePlanIdentified')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.OFFICE_TECHNICAL_COMPETENCIES' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="localOfficeTechnicalCompetencies" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'localOfficeTechnicalCompetencies')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'localOfficeTechnicalCompetencies')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.LOCAL_OFFICE_STAFFED' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="localOfficeStaffedForWork" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'localOfficeStaffedForWork')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'localOfficeStaffedForWork')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.SPECIAL_COMMISSIONING_PROCEDURES_REQUIRED'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="specialCommissioningProceduresRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialCommissioningProceduresRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialCommissioningProceduresRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.DESIGN_CONSIDERATIONS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="designConsiderations" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'designConsiderations')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'designConsiderations')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.UNION_PROJECT' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="unionProject" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'unionProject')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'unionProject')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="isFireOrSecurity">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.SPECIAL_TAGGING_REQUIREMENTS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="specialTaggingRequirements" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialTaggingRequirements')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'specialTaggingRequirements')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.RESPONSIBLE_FOR_HAZARDOUS_MATERIALS'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="responsibleForHazardousMaterials" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'responsibleForHazardousMaterials')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'responsibleForHazardousMaterials')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="row bottomPadding" *ngIf="isFire">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.CONFINED_WORK_SPACE' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="confinedWorkSpace" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'confinedWorkSpace')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'confinedWorkSpace')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding"
                        *ngIf="isFire && executionScheduleFormGroup.get('responsibleForInaccessibleAccess')?.value">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.RESPONSIBLE_FOR_INACCESSIBLE_ACCESS'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="responsibleForInaccessibleAccess" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'SIEMENS' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'responsibleForInaccessibleAccess')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'OTHER' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(executionScheduleFormGroup, 'responsibleForInaccessibleAccess')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1"
                    *ngIf="!costReviewFireEnUsExecutionSchedule?.isExecutionScheduleChecked && isReadMode">
                    <legend class="float-none w-auto font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="col-sm-6 ps-0" *ngIf="isFire">
            <div class="container-fluid h-100">
                <fieldset class="border rounded-3 p-1 h-100"
                    [formGroup]="outsidePurchaseFormGroup" [class.section-disabled]="isSectionFieldsetDisabled('outsidePurchaseFormGroup')" trackChanges>
                    <legend class="float-none w-auto font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.TITLE' | translate}} <si-check-box  [isReadMode]="false" [isDisabled]="isDisabled" [isChecked]="isSectionChecked('outsidePurchaseFormGroup')" (change)="onSectionToggle('outsidePurchaseFormGroup', $event)"></si-check-box></legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.SPECIAL_FABRICATIONS_ITEMS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="specialFabricationItems" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'specialFabricationItems')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'specialFabricationItems')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.HEATERS_REQUIRED_WITHIN_UNCONTROLLED_SPACE'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="heatersRequired" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'heatersRequired')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'heatersRequired')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.THIRD_PARTY_MATERIALS_IDENTIFIED' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="thirdPartyMaterialsIdentified" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'thirdPartyMaterialsIdentified')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'thirdPartyMaterialsIdentified')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.SUPPLIER_PART_NUMBERS_AND_PRICING_PROVIDED'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="supplierPartNumbers" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'supplierPartNumbers')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'supplierPartNumbers')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label>{{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.OUTSIDE_PURCHASE_SYSTEMS' |
                                translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="outsidePurchaseSystems" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'outsidePurchaseSystems')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'outsidePurchaseSystems')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row bottomPadding">
                        <div class="col-sm-6">
                            <mat-label
                                class="margin-left-10">{{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.IF_YES_REQUIRE_MANUFACTURER_OR_SUPPLIER_INSTALLATION'
                                | translate}}</mat-label>
                        </div>
                        <div class="col-sm-6">
                            <mat-radio-group class="radio-group radio-btns d-flex flex-row"
                                formControlName="ifYesRequireManufacturer" [disabled]="isReadMode">
                                <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isControlValueEqualToTranslation(outsidePurchaseFormGroup, 'outsidePurchaseSystems', 'YES')" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'ifYesRequireManufacturer')">
                                </si-radio-button>
                                <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadMode" [isDisabled]="isDisabled || !isControlValueEqualToTranslation(outsidePurchaseFormGroup, 'outsidePurchaseSystems', 'YES')" [selectedValue]="formControlsValueForString(outsidePurchaseFormGroup, 'ifYesRequireManufacturer')">
                                </si-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-1"
                   *ngIf="!costReviewEnUsOutsidePurchase?.isOutsidePurchasesApplicable && isReadMode">
                    <legend class="float-none w-auto font-size-13">
                        {{'REVIEW_SOL_CHECKLIST_TAB.OUTSIDE_PURCHASES.TITLE' | translate}}</legend>
                    <div class="row bottomPadding">
                        <div class="col-sm-12">
                            <span> {{'REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE' | translate}}</span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>








